import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="reset-page" className="min-h-[80vh] max-w-md mx-auto px-6 py-20">
      <div className="label-eyebrow text-sage mb-3">Folio account</div>
      <h1 className="font-serif text-5xl tracking-tight mb-2">New password.</h1>
      <p className="text-muted_ink mb-10">Choose a password you'll actually remember.</p>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="label-eyebrow block mb-2">New password</label>
          <Input
            data-testid="reset-password-input"
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-12 bg-transparent border border-edge rounded-none focus-visible:ring-terracotta focus-visible:ring-1"
          />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Confirm password</label>
          <Input
            data-testid="reset-confirm-input"
            type="password"
            required
            minLength={6}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="h-12 bg-transparent border border-edge rounded-none focus-visible:ring-terracotta focus-visible:ring-1"
          />
        </div>
        {error && (
          <div data-testid="reset-error" className="text-sm text-terracotta border-l-2 border-terracotta pl-3">{error}</div>
        )}
        <button
          data-testid="reset-submit-btn"
          type="submit"
          disabled={loading}
          className="btn-primary w-full disabled:opacity-60"
        >
          {loading ? "Updating…" : "Update password"}
        </button>
      </form>

      <div className="text-center mt-8 text-sm text-muted_ink">
        <Link to="/login" className="underline underline-offset-4 decoration-terracotta">Back to sign in</Link>
      </div>
    </div>
  );
}
